import { useEffect } from 'react';
import { updateSessionStore } from '@libs/catalog-service';
import { useRouter } from 'next/router';
import { Locale } from '@formatjs/intl-locale';

export const useSessionStoreInitializer = () => {
  const router = useRouter();
  const { locale: localeStr } = router;
  const { language, region: country } = new Locale(localeStr);

  useEffect(() => {
    const handleSessionKeepAlive = async () => {
      if (!router.isReady) {
        return;
      }

      await updateSessionStore({ language, country });
    };
    void handleSessionKeepAlive();
  }, [router.isReady]);
};
